import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { 
            Dialog, 
            DialogContent, 
            DialogTitle, 
            Grid,
            Button,
            Typography
        } from '@material-ui/core';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';

const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
        textAlign : "center"
    },
    buttonSubmit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        //borderLeft: '3px solid #0073D2',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            //borderLeft: '3px solid #0073D2',
        }
    },
    buttonRefresh: {
        color : 'white',
        backgroundColor : '#6878f2'
    },
    buttonCancel: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
    
    },
    dialogPaper: {
        height : '250px'
    },
    iconRefresh : {
        [theme.breakpoints.up('xs')]: {
            width: '45vw',
            height: '7vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('sm')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('lg')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        [theme.breakpoints.up('xl')]: {
            width: '45vw',
            height: '10vh',
            textAlign: 'center',
        },
        
    },
    textQuestion : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '150%',
            textAlign: 'justify',
        },
        
    },
    textButtons : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));

const validate = values => {
    const error  = {}
    if (!values.alias) {
        error.alias = "Este campo es obligatorio"
    }
    if (/^(?!\s)/.test(values.alias) === false) {
        error.alias = "Este campo no debe contener espacios en blanco al inicio."
    } 
    return error
}

const FormSaveAliasReferenceDialog = props => {

    const classes = useStyles();

    const {
        isOpenDialog, 
        onCloseDialog,
        titleDialog,
        handleSubmit,
        labelField,
        placeholderField,
        nameButtonActionSave,
        nameButtonActionCancel,
        invalid
    } = props;

    return (
        <Dialog
            open={ isOpenDialog }
            onClose={ onCloseDialog }
            //fullWidth={true}
            maxWidth= 'md'
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper : classes.dialogPaper}}
        >
            <DialogTitle id="form-dialog-title">
                <Typography align = {"center"}> { titleDialog } </Typography>
            </DialogTitle>
        
            <DialogContent>

                <form className={classes.form} onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <Field
                                name="alias"
                                id="alias"
                                autoFocus = { true }
                                component={ RenderTextFieldRedux }
                                label={labelField}
                                placeholder = {placeholderField}
                                defaultValue = {""}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                fullWidth
                                className={classes.buttonStandard}
                                disabled={invalid }
            
                            >
                                { nameButtonActionSave }
                            </Button>
                        </Grid>
                        
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                variant="contained" 
                                className={classes.buttonStandard}
                                onClick = { onCloseDialog }
                                fullWidth
                            >
                                { nameButtonActionCancel }
                            </Button>   
                        </Grid>
                    </Grid>
                </form>

            </DialogContent>
        </Dialog>
    )
}

const FormSaveAliasReferenceDialogReduxForm = reduxForm(
    {
        form: 'FormSaveAliasReferenceDialog',
        validate
    }
)(FormSaveAliasReferenceDialog)
export default FormSaveAliasReferenceDialogReduxForm
